import React from 'react';
import { FollowOrganizerProps, OrganizerPanelListingsProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';
import OrganizerPanelListings from './OrganizerPanelListings';

const ORGANIZER_PANEL_LISTINGS_ROOT_ID = 'listings-root__organizer-panel';

const OrganizerPanelListingsMount = (
    props: OrganizerPanelListingsProps & FollowOrganizerProps,
) =>
    dynaMount(
        {
            Component: OrganizerPanelListings,
            containerId: ORGANIZER_PANEL_LISTINGS_ROOT_ID,
        },
        props,
    );

const OrganizerPanelListingsRoot = (
    props: OrganizerPanelListingsProps & FollowOrganizerProps,
): JSX.Element | null => <OrganizerPanelListingsMount {...props} />;

export default OrganizerPanelListingsRoot;
